// Import Dependencies
import { Navigate } from "react-router-dom";
import { useOutlet } from "react-router";

// Local Imports
import { useAuthContext } from "app/contexts/auth/context";
import { HOME_PATH, REDIRECT_URL_KEY } from "constants/app.constant";
import { getFirstAvailableRoute } from "utils/navigationUtils";

// ----------------------------------------------------------------------


export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, user } = useAuthContext();

  const redirectParam = new URLSearchParams(window.location.search).get(
    REDIRECT_URL_KEY,
  );
  const redirectUrl = redirectParam && redirectParam !== "null" ? redirectParam : null;

  if (isAuthenticated) {
    if (redirectUrl) {
      return <Navigate to={redirectUrl} replace />;
    }
    const targetRoute = getFirstAvailableRoute(user) || HOME_PATH;
    return <Navigate to={targetRoute} replace />;
  }

  return <>{outlet}</>;
}
